import React, { Component, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About1 from './About';
import Home1 from './Home';
import Navbar from './HomeSection/Navbar/Navbar';
import Footer from './HomeSection/Footer/footer';
import Contact from './Contact/Contact';
import Popup from './PopUpForm/Popup';
import TopHeader from './HomeSection/TopHeader/TopHeader';
import Banner from '../src/Banner/Banner';
import Whatsapp from './Whatsapp';

import Gallery from './Gallery/Gallery';
import Thankyou from './Thankyou';
import MyAbout from './MyAbout/MyAbout';
import $ from 'jquery';
import ScrollToTopButton from './ScrollToTopButton';
import OurPrograms from './OurPrograms/OurPrograms';
import ScrollToTop from './ScrollToTop';

// Utility function to load external scripts
const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    // document.body.appendChild(script);
  });
};

function App() {
  const routes = [
    { path: '/', name: 'Home', Component: Home1 },
    { path: '/myabout', name: 'About Us', Component: MyAbout },
    { path: '/Gallery', name: 'Gallery', Component: Gallery },
    { path: '/OurPrograms', name: 'OurPrograms', Component: OurPrograms },
    { path: '/contact', name: 'Contact', Component: Contact },
  ];

  useEffect(() => {
    const loadScripts = async () => {
      try {
        // Load jQuery
        await loadScript('https://code.jquery.com/jquery-3.7.1.min.js');
        
        // Load plugin scripts
        await loadScript('./a-for-apple/wp-content/plugins/ti-woocommerce-wishlist/assets/js/public.min.js'); // Adjust path accordingly
        await loadScript('./a-for-apple/wp-content/plugins/wedesigntech-portfolio/assets/js/common.js');     // Adjust path accordingly
        await loadScript('./a-for-apple/wp-content/plugins/wedesigntech-portfolio/assets/js/frontend.js');   // Adjust path accordingly

        // Ensure plugins or functions are defined before calling them
        if (window.tinvwl_add_to_wishlist) {
          // Initialize TI WooCommerce Wishlist plugin
          window.tinvwl_add_to_wishlist();
        }

        if (window.wdtcommonobject) {
          // Initialize WeDesignTech Portfolio plugin
          if (typeof window.wdtcommonobject.init === 'function') {
            window.wdtcommonobject.init();
          }
        }

        if (window.wdtfrontendobject) {
          // Initialize frontend specific functions
          if (typeof window.wdtfrontendobject.init === 'function') {
            window.wdtfrontendobject.init();
          }
        }
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    loadScripts();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Popup />
      <TopHeader />
      <Navbar />

      <Routes>
   
        {routes.map(({ path, name, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <>
                {path !== '/' && (
                  <Banner 
                    title={name} 
                    breadcrumbs={[
                      { text: 'Home', link: '/' },
                      { text: name, link: path }
                    ]}
                  />
                )}
               
                <Component />
              </>
            }
          />
        ))}
        <Route path='/thankyou' element={<Thankyou/>}/>
      </Routes>
      <Whatsapp />
     
      <Footer />
     
    </Router>
  );
}

export default App;